@if (editable) {
    @switch (type) {
        @case (_TableCellType.text) {
            <p-cellEditor>
                <ng-template pTemplate="input">
                    <sm-form *ngIf="editorForm != null" [form]="editorForm">
                    </sm-form>
                    <input *ngIf="editorForm == null" pInputText class="width100p" [maxlength]="editableMaxLength > 0 ? editableMaxLength : undefined" [(ngModel)]="_value" (ngModelChange)="afterEdit()">
                </ng-template>
                <ng-template pTemplate="output">
                    <span *ngIf="showNull && _value == null" class="badge badge-no" (click)="buttonClick($event)">null</span>
                    {{_value}}
                </ng-template>
            </p-cellEditor>
        }
        @case (_TableCellType.int) {
            <p-cellEditor>
                <ng-template pTemplate="input">
                    <p-inputNumber class="width100p" [(ngModel)]="_value" (ngModelChange)="afterEdit()"></p-inputNumber>
                </ng-template>
                <ng-template pTemplate="output">
                    <span *ngIf="showNull && _value == null" class="badge badge-no" (click)="buttonClick($event)">null</span>
                    {{_value}}
                </ng-template>
            </p-cellEditor>
        }
        @case (_TableCellType.byteSize) {
            <p-cellEditor>
                <ng-template pTemplate="input">
                    <p-inputNumber class="width100p" [(ngModel)]="_value" (ngModelChange)="afterEdit()"></p-inputNumber>
                </ng-template>
                <ng-template pTemplate="output">
                    <span *ngIf="showNull && _value == null" class="badge badge-no" (click)="buttonClick($event)">null</span>
                    {{_Utils.toByteSizeString(_value)}}
                </ng-template>
            </p-cellEditor>
        }
        @case (_TableCellType.duration) {
            <p-cellEditor>
                <ng-template pTemplate="input">
                    <p-inputNumber class="width100p" [(ngModel)]="_value" (ngModelChange)="afterEdit()"></p-inputNumber>
                </ng-template>
                <ng-template pTemplate="output">
                    <span *ngIf="showNull && _value == null" class="badge badge-no" (click)="buttonClick($event)">null</span>
                    {{_Utils.toDurationStringAdvanced(_value, 2, true)}}
                </ng-template>
            </p-cellEditor>
        }
        @case (_TableCellType.durationNanos) {
            <p-cellEditor>
                <ng-template pTemplate="input">
                    <p-inputNumber class="width100p" [(ngModel)]="_value" (ngModelChange)="afterEdit()"></p-inputNumber>
                </ng-template>
                <ng-template pTemplate="output">
                    <span *ngIf="showNull && _value == null" class="badge badge-no" (click)="buttonClick($event)">null</span>
                    {{_Utils.toDurationStringAdvancedNanos(_value, 2, true)}}
                </ng-template>
            </p-cellEditor>
        }
        @case (_TableCellType.yesNo) {
            <p-checkbox *ngIf="type == _TableCellType.yesNo" [binary]=true [(ngModel)]="_value" (ngModelChange)="afterEdit()" (click)="$event.stopPropagation()"></p-checkbox>
        }
        @case (_TableCellType.color) {
            <p-cellEditor>
                <ng-template pTemplate="input">
                    <input pInputText [(ngModel)]="_value">
                </ng-template>
                <ng-template pTemplate="output">
                    <span *ngIf="showNull && _value == null" class="badge badge-no" (click)="buttonClick($event)">null</span>
                    {{_value}}
                </ng-template>
            </p-cellEditor>
        }
        @case (_TableCellType.dateTime) {
            <p-cellEditor>
                <ng-template pTemplate="input">
                    <p-calendar class="width100p" [(ngModel)]="_value" dateFormat="dd.mm.yy" appendTo="body" (ngModelChange)="afterEdit()"></p-calendar>
                </ng-template>
                <ng-template pTemplate="output">
                    <span *ngIf="showNull && _value == null" class="badge badge-no" (click)="buttonClick($event)">null</span>
                    {{_Utils.isString(_value) ? _value : _value | date: 'dd.MM.yyyy mm:ss'}}
                </ng-template>
            </p-cellEditor>
        }
        @case (_TableCellType.date) {
            <p-cellEditor>
                <ng-template pTemplate="input">
                    <p-calendar class="width100p" [(ngModel)]="_value" dateFormat="dd.mm.yy" appendTo="body" (ngModelChange)="afterEdit()"></p-calendar>
                </ng-template>
                <ng-template pTemplate="output">
                    <span *ngIf="showNull && _value == null" class="badge badge-no" (click)="buttonClick($event)">null</span>
                    {{_Utils.isString(_value) ? _value : _value | date: 'dd.MM.yyyy'}}
                </ng-template>
            </p-cellEditor>
        }
        @case (_TableCellType.button) {
            <p-cellEditor>
                <ng-template pTemplate="input">
                    <input pInputText [(ngModel)]="_value">
                </ng-template>
                <ng-template pTemplate="output">
                    <span *ngIf="showNull && _value == null" class="badge badge-no" (click)="buttonClick($event)">null</span>
                    {{_value}}
                </ng-template>
            </p-cellEditor>
        }
        @case (_TableCellType.link) {
            <p-cellEditor>
                <ng-template pTemplate="input">
                    <input pInputText class="width100p" [(ngModel)]="_value" (ngModelChange)="afterEdit()">
                </ng-template>
                <ng-template pTemplate="output">
                    <span *ngIf="showNull && _value == null" class="badge badge-no" (click)="buttonClick($event)">null</span>
                    {{_value}}
                </ng-template>
            </p-cellEditor>
        }
    }
}
@else if (_value != null) {
    <div *ngIf="actionButtons && mouseInside" class="action-button-wrapper">
        <button pButton type="button" class="action-button p-button-text" [icon]="'fas fa-bars'" (click)="actionButtonClick($event)"></button>
    </div>
    @switch (type) {
        @case (_TableCellType.text) {
            @if (tableCell?.keepHtml) {
                <span [innerHTML]="_value | keepHtml" appDynamicTooltip (onToolTip)="handleTooltip($event)" [class.no-wrap-cell]="noWrapCell">{{_value}}</span>
            }
            @else {
                <span appDynamicTooltip (onToolTip)="handleTooltip($event)" [class.no-wrap-cell]="noWrapCell">{{_value}}</span>
            }
        }
        @case (_TableCellType.link) {
            <span><a href="#" (click)="buttonClick($event)" [class.no-wrap-cell]="noWrapCell">{{_value}}</a></span>
        }
        @case (_TableCellType.int) {
            <span [class.no-wrap-cell]="noWrapCell">{{_value}}</span>
        }
        @case (_TableCellType.byteSize) {
            <span [class.no-wrap-cell]="noWrapCell">{{_Utils.toByteSizeString(_value, false)}}</span>
        }
        @case (_TableCellType.duration) {
            <span [class.no-wrap-cell]="noWrapCell">{{_Utils.toDurationStringAdvanced(_value, 2, true)}}</span>
        }
        @case (_TableCellType.durationNanos) {
            <span [class.no-wrap-cell]="noWrapCell">{{_Utils.toDurationStringAdvancedNanos(_value, 2, true)}}</span>
        }
        @case (_TableCellType.icon) {
            <span [class.no-wrap-cell]="noWrapCell"><i [class]="_value + ' icon'"></i></span>
        }
        @case (_TableCellType.yesNo) {
            <span class="badge" [class.badge-yes]="_value" [class.badge-no]="!_value" [class.no-wrap-cell]="noWrapCell">{{_value ? "Ja" : "Nein"}}</span>
        }
        @case (_TableCellType.color) {
            <span class="badge" [style.background]="_Utils.toColorHexString(_value)" [class.no-wrap-cell]="noWrapCell">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        }
        @case (_TableCellType.date) {
            <span [class.no-wrap-cell]="noWrapCell">{{_Utils.isDate(_value) ? (_value | date:'dd.MM.yyyy') : ''}}</span>
        }
        @case (_TableCellType.dateTime) {
            <span [class.no-wrap-cell]="noWrapCell">{{_Utils.isDate(_value) ? (_value | date:'dd.MM.yyyy HH:mm:ss') : ''}}</span>
        }
        @case (_TableCellType.button) {
            <span [class.no-wrap-cell]="noWrapCell">
                <button *ngFor="let icon of _Utils.split(_value, ',')" pButton type="button" class="p-button-text" [icon]="icon" (click)="buttonClick($event, icon)"></button>
            </span>
        }
    }
}
